// @ts-nocheck
import mapboxgl from 'mapbox-gl';
import { PropsWithChildren, ReactNode, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

import { MAP_LAYERS } from '../../../../components/map/constants.js';

interface MapPopupProps {
  map: mapboxgl.Map | undefined;
  lat: number;
  lng: number;
  onClose?: () => void;
}
/** CAUTION the onclose prop must be referentially stable, if provided */
export function MapPopup({ map, lat, lng, onClose, children }: PropsWithChildren<MapPopupProps>) {
  const mbTooltip = useRef(
    new mapboxgl.Popup({
      offset: 15,
      closeButton: false,
      closeOnClick: false, // We handle closing the popup ourselves
    }),
  );
  const tooltipContentElement = useRef(document.createElement('div'));

  useEffect(() => {
    if (!map) return;

    const currMbTooltip = mbTooltip.current;

    const popup = mbTooltip.current
      .setLngLat([lng, lat])
      .setDOMContent(tooltipContentElement.current)
      .addTo(map);

    // HACK: This closes the popup when the user clicks outside the pin layer
    //  If we didn't include this, one of the pair popups could appear to stay
    //  closed, while the other would remain open.
    const maybeClosePopup = (e: mapboxgl.MapMouseEvent) => {
      const pinFeatures = map?.queryRenderedFeatures(e.point, {
        layers: [MAP_LAYERS.PINS],
      });
      const hasClickedPin = !!pinFeatures?.length;
      if (!hasClickedPin) {
        popup.remove();
        onClose?.();
      }
    };

    map.on('click', maybeClosePopup);

    return () => {
      currMbTooltip.remove();
      map.off('click', maybeClosePopup);
    };
  }, [lat, lng, map, onClose]);

  if (!lat || !lng || !map || !tooltipContentElement.current) {
    return null;
  }

  return createPortal(children, tooltipContentElement.current) as ReactNode;
}
